























































































import { AxiosError } from 'axios';
import { TeipNotifications } from '@/util/teipNotifications';
import root from '@/store/types/root';
import transaction from '@/store/types/transaction';
import { TransactionParams } from '@/store/interfaces/transactions';
import { ValidationProvider } from 'vee-validate';
import copyObj from '@/util/copyObj';
import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { currencyKeyboardEventValidation } from '@/util/CurrencyValidation';

export default Vue.extend({
  name: 'TransactionRefundModal',
  props: {
    viewDetails: {
      type: Boolean,
      required: true,
    },
    paymentRequest: {
      type: Object as PropType<TransactionParams>,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getProccess: root.getters.GET_START_PROCESS,
    }),
    syncedViewDetails: {
      get(): boolean {
        return this.viewDetails;
      },
      set(val: boolean): void {
        this.$emit('update:viewDetails', val);
      },
    },
  },
  data() {
    return {
      refund: {
        kind: 'full',
        tip_cents: 0,
        subtotal_cents: 0,
      },
      isDisabledInput: true,
      currencyKeyboardEventValidation: currencyKeyboardEventValidation,
    };
  },
  methods: {
    ...mapActions({
      paymenteRefund: `transactionModule/${transaction.actions.PAYMENT_REFUND}`,
    }),
    setRefund(): void {
      this.refund.tip_cents = this.formattedDollar(
        this.paymentRequest.tip_formatted
      );
      this.refund.subtotal_cents = this.formattedDollar(
        this.paymentRequest.subtotal_formatted
      );
    },
    formattedDollar(dollar: string): number {
      let dol = dollar;
      if (dollar[0] === '$') {
        dol = dollar.substring(1);
      }
      return Number(dol);
    },
    cancel(): void {
      this.refund.kind = 'full';
      this.syncedViewDetails = false;
    },
    async firstFormSubmit(): Promise<void> {
      const data = copyObj(this.refund);
      data.subtotal_cents = data.subtotal_cents * 100;
      data.tip_cents = data.tip_cents * 100;

      const dataToSend = {
        id: this.paymentRequest.id,
        data,
      };
      const notification = new TeipNotifications();
      this.paymenteRefund(dataToSend)
        .then(() => {
          this.syncedViewDetails = false;
          this.cancel();
          notification.success('Devolución solicitado con éxito');
        })
        .catch((err: AxiosError) => {
          if (err.response?.status === 422) {
            (
              this.$refs.formRefundValidator as InstanceType<
                typeof ValidationProvider
              >
            ).setErrors(err.response.data.error);
          } else {
            notification.warning('Algo salió mal :(');
          }
        });
    },
  },
  watch: {
    'refund.kind': {
      immediate: true,
      deep: true,
      handler(val: string): void {
        if (Object.keys(this.paymentRequest).length > 0) {
          if (val === 'full') {
            this.isDisabledInput = true;
          } else {
            this.isDisabledInput = false;
          }
          this.setRefund();
        }
      },
    },
    paymentRequest: {
      deep: true,
      handler(): void {
        this.setRefund();
      },
    },
  },
});
